import { render, staticRenderFns } from "./tradeOrderModal.vue?vue&type=template&id=181b7424&scoped=true&"
import script from "./tradeOrderModal.vue?vue&type=script&lang=js&"
export * from "./tradeOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b7424",
  null
  
)

export default component.exports